<div class="flex flex-col p-6 bg-card shadow rounded-2xl overflow-hidden cursor-pointer" (click)="onClicked()">
  <div class="flex items-center justify-between">
    <div class="flex flex-row gap-2">
      <mat-icon class="icon-size-5">{{ tool.icon }}</mat-icon>
      <div class="text-xl font-semibold leading-tight">{{ tool.label }}</div>
    </div>
  </div>
  <div class="mt-4 text-sm text-secondary" [innerHTML]="tool.tips"></div>
</div>
